import React, { useRef, useEffect } from 'react';
import './Boots.scss';
import videomov from '../../../../assets/apollo/boots/apollo_boots_desktop.mov';
import video from '../../../../assets/apollo/boots/apollo_boots_desktop.webm';
import poster from '../../../../assets/apollo/boots/apollo_boots_desktop_poster.png';

function ApolloBoots({ apolloBootsRef }) {
  const videoRef = useRef();

  useEffect(() => {
    const videoCurrent = videoRef.current;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            videoCurrent.play();
          }
        });
      },
      { threshold: [0, 0.1] }
    );
    observer.observe(videoCurrent);
  }, []);

  return (
    <section className="boots boots-apollo" ref={apolloBootsRef}>
      <div className=" boots__text boots__text-apollo">
        <h3 className="boots__text__title">
          A7L boots comprised an inner pressurized boot and a protective outer boot.
        </h3>
        <p className="boots__text__copy">
          Astronauts found that while the inner boot was snug, the outer boot slipped around,
          compromising their mobility and balance — meaning that some of the first steps on the moon
          were more like hops.
        </p>
      </div>
      <div className="boots__animation boots__animation-apollo">
        <video muted playsInline preload="auto" ref={videoRef} className="video" poster={poster}>
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
      <div className="boots__text boots__text-apollo">
        <p className="boots__text__copy">
          To counter the weight of the lunar rocks they brought home, the first moonwalkers left
          their outer boots behind on the moon.
        </p>
      </div>
    </section>
  );
}

export default ApolloBoots;
